import React from "react";
import "./style.scss";

const GenericTable = ({ data, isUtterance }) => {
  return (
    <table className="generic_table_container">
      <tbody>
        <tr className="header">
          {!isUtterance ? (
            <>
              <th>Intents</th>
              <th>Count</th>
            </>
          ) : (
            <>
              <th>Utterances</th>
              <th>Count</th>
            </>
          )}
        </tr>
        {data && data.data.length ? (
          data.data.map((el, key) => (
            <tr key={`top-intent-${key}`}>
              <td>{!isUtterance ? el.request_name : el.utterances}</td>
              <td>{!isUtterance ? el.IntentCount : el.utterancescount}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td>No {!isUtterance ? "Intent" : "Utterance"}</td>
            <td></td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default GenericTable;
